import React from "react";
import { Form, Button } from "react-bootstrap";
import "./CommonStructuredV2.css";

const CommonStructuredV2 = ({
  onClickCreateBtn,
  onClickCreateBtn1,
  pageHeading,
  createBtnTxt,
  createBtnTxt1,
  createBtnTxt2,
  onClickCreateBtn2,
  createBtnTxt3,
  onClickCreateBtn3,
  isReload,
  onClickBackBtn,
  isCheckboxBtn,
  isEnableFdCreation,
  setIsFdCreation,
  isLoading,
  onCloseModal,
}) => {
  return (
    <div className="structured-v2-main-container">
      <div className="structured-v2-inner-container">
        <div className="structured-v2-header-wrapper">
          <div className="structured-v2-header">
            <div className="structured-v2-title-section">
              <div className="structured-v2-title-section-wrapper">
                <h1 className="structured-v2-page-heading">{pageHeading}</h1>
                {isReload && (
                  <button
                    type="button"
                    onClick={isReload}
                    className="structured-v2-reload-btn"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-arrow-clockwise"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fillRule="evenodd"
                        d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z"
                      />
                      <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466" />
                    </svg>
                  </button>
                )}
              </div>
            </div>

            <div className="structured-v2-actions-section">
              <div className="structured-v2-actions-container">
                {isCheckboxBtn && (
                  <div className="structured-v2-checkbox-wrapper">
                    <Form.Check
                      type="checkbox"
                      id="structured-v2-checkbox"
                      className={`structured-v2-checkbox ${
                        isEnableFdCreation ? "green" : ""
                      }`}
                      label="Enable FD Create Option"
                      checked={isEnableFdCreation}
                      onChange={(e) => setIsFdCreation(e.target.checked)}
                      disabled={isLoading}
                    />
                  </div>
                )}

                {onClickBackBtn && (
                  <Button
                    type="button"
                    variant="dark"
                    className="structured-v2-btn structured-v2-back-btn"
                    onClick={onClickBackBtn}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-arrow-left"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fillRule="evenodd"
                        d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8"
                      />
                    </svg>
                    <span>Back</span>
                  </Button>
                )}

                {createBtnTxt && (
                  <Button
                    type="button"
                    variant="danger"
                    className="structured-v2-btn structured-v2-action-btn"
                    onClick={onClickCreateBtn}
                  >
                    {createBtnTxt}
                  </Button>
                )}

                {createBtnTxt2 && (
                  <Button
                    type="button"
                    variant="danger"
                    className="structured-v2-btn structured-v2-action-btn"
                    onClick={onClickCreateBtn2}
                  >
                    {createBtnTxt2}
                  </Button>
                )}

                {createBtnTxt3 && (
                  <Button
                    type="button"
                    variant="danger"
                    className="structured-v2-btn structured-v2-action-btn"
                    onClick={onClickCreateBtn3}
                  >
                    {createBtnTxt3}
                  </Button>
                )}

                {createBtnTxt1 && (
                  <Button
                    type="button"
                    variant="danger"
                    className={`structured-v2-btn structured-v2-action-btn ${
                      createBtnTxt1 === "Reload"
                        ? "structured-v2-reload-action"
                        : ""
                    }`}
                    onClick={onClickCreateBtn1}
                  >
                    {createBtnTxt1 === "Reload" && (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-arrow-clockwise"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fillRule="evenodd"
                          d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z"
                        />
                        <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466" />
                      </svg>
                    )}
                    <span>{createBtnTxt1}</span>
                  </Button>
                )}

                {onCloseModal && (
                  <Button
                    type="button"
                    variant="danger"
                    className="notmalButtonStyles smallText"
                    onClick={onCloseModal}
                    style={{
                      height: "50px",
                      width: "50px",
                      background: "#171717",
                      border: "none",
                      borderRadius: "50%",
                    }}
                  >
                    X
                  </Button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CommonStructuredV2;
